import { useEffect, useRef } from 'react'

import { ExclamationCircleFilled } from '@ant-design/icons'
import { Alert } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useCrudFormStore } from '../Store/hooks/useStore'

export const CrudFormSubmitError = () => {
  const ref = useRef<HTMLDivElement>(null)
  const { submitError } = useCrudFormStore(state =>
    pick(state, ['submitError'])
  )

  useEffect(() => {
    if (submitError) {
      ref.current?.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }, [submitError])

  return submitError ? (
    <div ref={ref}>
      {submitError && (
        <Alert
          showIcon
          closable={false}
          description={submitError.message}
          icon={<ExclamationCircleFilled />}
          title='操作失败'
          type='error'
          style={{
            whiteSpace: 'pre-line'
          }}
        />
      )}
    </div>
  ) : null
}
